import { Feature } from "ol";
import { config } from "./config";

const fields = config.search.fields;

export const filterByText = (features: Feature[], searchText: string): Feature[] => {
    if (!features || !features.length || !fields || !fields.length) {
        return [];
    }

    const result = features.filter((feature) => {
        let includes = false;
        for (let i = 0; i < fields.length; i++) {
            const value = feature.get(fields[i]);
            if (value && value.toLowerCase().includes(searchText.toLowerCase())) {
                includes = true;
                break;
            }
        }
        return includes;
    });
    return result;
};
